import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideUp = keyframes`
  from { transform: translateY(24px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  animation: ${fadeIn} 0.15s ease-out;
`;

export const Modal = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 90vw;
    max-width: 900px;
    height: 85vh;
    background: ${theme.colors.surfaceContainerLow};
    border: 1px solid ${theme.colors.outlineVariant};
    border-radius: ${theme.borderRadius.large};
    display: flex;
    flex-direction: column;
    overflow: hidden;
    animation: ${slideUp} 0.2s ease-out;
    box-shadow: 0 24px 48px rgba(0, 0, 0, 0.4);
  `}
`;

export const ModalHeader = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.spacing.level5} ${theme.spacing.level6};
    border-bottom: 1px solid ${theme.colors.outlineVariant};
    flex-shrink: 0;
  `}
`;

export const ModalTitle = styled.h2`
  ${({ theme }) => css`
    font-size: ${theme.font.titleLarge.fontSize};
    font-weight: 600;
    color: ${theme.colors.onSurface};
    margin: 0;
    font-family: ${theme.font.titleLarge.fontFamily}, sans-serif;
  `}
`;

export const CloseButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: none;
    border-radius: ${theme.borderRadius.small};
    background: transparent;
    color: ${theme.colors.onSurfaceVariant};
    font-size: 20px;
    cursor: pointer;
    transition: all 0.15s;

    &:hover {
      background: ${theme.colors.surfaceContainer};
      color: ${theme.colors.onSurface};
    }
  `}
`;

export const ModalBody = styled.div`
  flex: 1;
  overflow: hidden;
`;

export const PdfFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

export const FallbackMessage = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: ${theme.spacing.level4};
    color: ${theme.colors.onSurfaceVariant};
    font-size: ${theme.font.bodyLarge.fontSize};

    a {
      color: ${theme.colors.primary};
      text-decoration: none;
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }
    }
  `}
`;
